import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import { useStorage } from '@vueuse/core'
import { RouterNames } from './router.consts'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: RouterNames.Home,
    component: () => import('@/views/Home/Home.vue'),
    redirect: () => {
      return { name: RouterNames.Login, params: { id: '' } }
    },
    children: [
      {
        path: '/:id/details',
        name: RouterNames.Details,
        component: () => import('@/views/Details/DetailsPage.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: '/:id/gallery',
        name: RouterNames.Gallery,
        component: () => import('@/views/Gallery/GalleryPage.vue'),
        props: (route) => {
          return {
            presentation: route.query?.presentation,
          }
        },
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: '/404',
    name: RouterNames.NotFound,
    component: () => import('@/views/NotFound/NotFound.vue'),
  },
  {
    path: '/:id',
    name: RouterNames.Login,
    component: () => import('@/views/Login/Login.vue'),
  },
  {
    path: '*',
    redirect: () => {
      return { name: RouterNames.Login }
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
})

router.beforeEach((to, from, next) => {
  console.log('[Router] Navigation guard triggered:', {
    from: from.name,
    to: to.name,
    toParams: to.params,
    requiresAuth: to?.meta?.requiresAuth
  })

  const galleryId = useStorage('galleryId', '')
  const accessToken = useStorage('accessToken', '')
  console.log('[Router] Current auth state:', {
    galleryId: galleryId.value,
    hasAccessToken: !!accessToken.value
  })

  const _galleryId = to.params.id
  if (_galleryId && _galleryId !== galleryId.value) {
    console.log('[Router] Gallery ID changed, clearing access token')
    galleryId.value = _galleryId
    accessToken.value = null
  }

  if (accessToken.value && to.name === RouterNames.Login && to.params.id) {
    console.log('[Router] Already authenticated, checking for redirect parameter')
    const redirectTo = to.query.redirect as string | undefined
    if (redirectTo) {
      console.log('[Router] Redirecting to stored destination:', redirectTo)
      next(redirectTo)
    } else {
      console.log('[Router] No redirect parameter, redirecting to Details')
      next({ name: RouterNames.Details, params: { id: to.params.id } })
    }
    return
  }

  if (to?.meta?.requiresAuth && !accessToken.value) {
    console.log('[Router] Route requires auth but no token, redirecting to Login with redirect parameter')
    next({
      name: RouterNames.Login,
      params: { id: to.params.id || galleryId.value },
      query: { redirect: to.fullPath },
    })
  } else {
    console.log('[Router] Navigation allowed, proceeding to:', to.name)
    next()
  }
})

export default router
